/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* utilities */
import { parseDataToProps } from '../../utilities';

const searchNodes = Array.from(document.querySelectorAll('.search'));
if (searchNodes.length) {
    import(/* webpackChunkName: "Search" */ './components/Search').then(({ default: Search }) => {
        searchNodes.forEach((node) => createRoot(node).render(<Search {...parseDataToProps(node.dataset)}/>));
    });
}
